import { createFileRoute, Outlet } from "@tanstack/react-router";

// শুধু লেআউট — ইনডেক্স পেজ `bn.case-studies.index.tsx`-এ, যাতে ডিটেইল পেজে
// ডুপ্লিকেট ক্যানোনিক্যাল/hreflang না যায়।
export const Route = createFileRoute("/bn/case-studies")({
  component: () => <Outlet />,
});
